import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { APP_API_URL } from '../../utils';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

const isActiveValue = (value) => Number(value) === 1 || value === true;

export default function Update({ open, onClose, item, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    titre: '',
    description: '',
    statut: true,
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!item) return;
    setFormData({
      titre: item.titre,
      description: item.description || '',
      statut: isActiveValue(item.statut),
      user_id: user?.id,
    });
    setErrors({});
  }, [item, user?.id]);

  if (!open || !item) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${APP_API_URL}/postes/${item.id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: 'Le poste a été modifié avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Une erreur est survenue. Veuillez réessayer.',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title={`Modifier — ${item.titre}`}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={onClose} disabled={isLoading}>
            Annuler
          </button>
          <button
            type="submit"
            form={`update-poste-form-${item.id}`}
            className="duo-btn duo-btn--primary"
            disabled={isLoading}
          >
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id={`update-poste-form-${item.id}`} onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor={`poste-titre-${item.id}`} className="duo-form-label">
            Titre du poste *
          </label>
          <input
            type="text"
            className="duo-input"
            id={`poste-titre-${item.id}`}
            name="titre"
            value={formData.titre}
            onChange={handleChange}
          />
          {errors.titre && <p className="text-danger small mt-1 mb-0">{errors.titre[0]}</p>}
        </div>
        <div className="duo-form-group">
          <label htmlFor={`poste-description-${item.id}`} className="duo-form-label">
            Description
          </label>
          <textarea
            className="duo-input"
            id={`poste-description-${item.id}`}
            name="description"
            rows={3}
            value={formData.description}
            onChange={handleChange}
          />
          {errors.description && <p className="text-danger small mt-1 mb-0">{errors.description[0]}</p>}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              name="statut"
              checked={formData.statut}
              onChange={handleChange}
            />
            <span>
              Poste actif
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour rendre le poste inactif.
              </span>
            </span>
          </label>
        </div>
      </form>
    </DuoModal>
  );
}
